import { PuppyClips , PuppyClipId, PuppyClipName} from "./puppyclips";
import {
  PuppyPosture,
  PuppyRestLoop,
  PuppyTransitionPlan,
  PuppyTravelMode,
} from "./puppytypes";

function resolve_move_loop(mode: PuppyTravelMode) {
  switch (mode) {
    case "casual":
      return PuppyClips.Walk_F_RM;
    case "energetic":
      return PuppyClips.Trot_F_RM;
    case "aggressive":
      return PuppyClips.Run_F_RM;
  }
}

function default_arrive_loop(from: PuppyPosture): PuppyRestLoop {
  switch (from) {
    case "sleeping":
      return PuppyClips.Sitting_loop_1;
    case "lying":
      return PuppyClips.Lie_loop_1;
    case "sitting":
      return PuppyClips.Sitting_loop_1;
    case "idle":
    default:
      return PuppyClips.Idle_1;
  }
}

export function resolve_transition_plan(
  posture: PuppyPosture,
  mode: PuppyTravelMode
): PuppyTransitionPlan {
  if (posture === "sleeping") {
    return {
      enterOneShots:
        mode === "aggressive"
          ? [PuppyClips.Lie_Sleep_end, PuppyClips.Jump_Inplace_Full]
          : [PuppyClips.Lie_Sleep_end],
      moveLoop: resolve_move_loop(mode),
      arriveOneShots: [PuppyClips.Sitting_start],
      arriveLoop: PuppyClips.Sitting_loop_1,
    };
  }

  if (posture === "lying") {
    return {
      enterOneShots: [PuppyClips.Lie_end],
      moveLoop: resolve_move_loop(mode),
      arriveOneShots: [PuppyClips.Lie_start],
      arriveLoop: PuppyClips.Lie_loop_1,
    };
  }

  if (posture === "sitting") {
    return {
      enterOneShots: [PuppyClips.Sitting_end],
      moveLoop: resolve_move_loop(mode),
      arriveOneShots: [PuppyClips.Sitting_start],
      arriveLoop: PuppyClips.Sitting_loop_1,
    };
  }

  return {
    enterOneShots: [],
    moveLoop: resolve_move_loop(mode),
    arriveOneShots: [],
    arriveLoop: default_arrive_loop(posture),
  };
}

export const PuppyClipNamesById: Record<PuppyClipId, PuppyClipName> =
  Object.fromEntries(
    Object.entries(PuppyClips).map(([name, id]) => [id, name])
  ) as Record<PuppyClipId, PuppyClipName>;

export function clip_name(id: PuppyClipId): PuppyClipName {
  return PuppyClipNamesById[id];
}